/**
 * Billing permission-gating messages, ported from the Ember `app/utils/route-access.ts`
 * constants. Used by the billing service to explain why an upgrade / billing action is
 * disabled (verification rejected, masquerading read-only, or missing permission).
 */

const ACCEPTABLE_USE_POLICY = 'Acceptable Use Policy';
const CONTACT_SUPPORT_SENTENCE = 'If you believe this is an error, contact support.';

/** Banner title for the rejected-verification state. */
export const VERIFICATION_REJECTED_TITLE = 'Account not approved';

/**
 * Banner description: leads with the reason, since the Banner title already states the outcome.
 * Use with {@link VERIFICATION_REJECTED_TITLE} on Banners.
 */
export const VERIFICATION_REJECTED_DESCRIPTION = `The email domain and website information provided at signup does not align with our ${ACCEPTABLE_USE_POLICY}. ${CONTACT_SUPPORT_SENTENCE}`;

/**
 * One-sentence variant for disabled-button tooltips (Pluma tooltips are limited to a single
 * sentence). The Banner surfaces use {@link VERIFICATION_REJECTED_DESCRIPTION} instead.
 */
export const VERIFICATION_REJECTED_TOOLTIP = `Your account wasn't approved under our ${ACCEPTABLE_USE_POLICY}, so contact support to resolve this.`;

/**
 * Full standalone message (states the outcome and the reason) for surfaces that can hold more than
 * one sentence and have no separate title — route snackbars and the Ember-ported gates. Passive
 * voice ("information provided", not "you provided") avoids implied blame in an account error.
 */
export const VERIFICATION_REJECTED_MESSAGE = `Your account was not approved because the email domain and website information provided at signup does not align with our ${ACCEPTABLE_USE_POLICY}. ${CONTACT_SUPPORT_SENTENCE}`;

export const MASQ_READ_ONLY_MESSAGE = 'You cannot make changes while in read-only mode.';

export const NO_BILLING_PERMISSION_MESSAGE =
  'You do not have permission to manage billing. Contact your admin to update permissions.';

/**
 * One-sentence variant of {@link NO_BILLING_PERMISSION_MESSAGE} for disabled-button tooltips (Pluma
 * tooltips are limited to a single sentence).
 */
export const NO_BILLING_PERMISSION_TOOLTIP = 'Contact your admin for permission to manage billing.';

/** Disabled-button tooltip for a viewer without `account/edit`. */
export const NO_ACCOUNT_EDIT_PERMISSION_TOOLTIP = 'Contact your admin for permission to edit account details.';
